module.exports = __webpack_public_path__ + "media/images/lane/icon_send-a1e4748e0036af204da7742fe11297d2.svg";